var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGs9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 146,
    viewBox: "0 0 151 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1322_109733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.4104 143.52C104.38 143.52 131.919 115.982 131.919 82.012C131.919 48.042 104.38 20.5039 70.4104 20.5039C36.4404 20.5039 8.90234 48.042 8.90234 82.012C8.90234 115.982 36.4404 143.52 70.4104 143.52Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4105 138.428C101.568 138.428 126.827 113.17 126.827 82.0121C126.827 50.8542 101.568 25.5957 70.4105 25.5957C39.2526 25.5957 13.9941 50.8542 13.9941 82.0121C13.9941 113.17 39.2526 138.428 70.4105 138.428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2067 89.7517C74.3685 89.7517 77.7424 86.3778 77.7424 82.2159C77.7424 78.054 74.3685 74.6802 70.2067 74.6802C66.0448 74.6802 62.6709 78.054 62.6709 82.2159C62.6709 86.3778 66.0448 89.7517 70.2067 89.7517Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8359 28.4473H68.5771V34.5573H71.8359V28.4473Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8359 129.875H68.5771V135.985H71.8359V129.875Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5479 83.8451V80.5864H16.4378V83.8451H22.5479Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0342 85.4869L70.8191 79.1191L105.714 98.4455L68.0342 85.4869Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.354 5.63623H62.4678V23.9665H78.354V5.63623Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4103 10.7279C80.5338 10.7279 88.7405 8.44824 88.7405 5.63616C88.7405 2.82408 80.5338 0.544434 70.4103 0.544434C60.2868 0.544434 52.0801 2.82408 52.0801 5.63616C52.0801 8.44824 60.2868 10.7279 70.4103 10.7279Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.729 92.9086L103.711 94.3343C103.711 94.3343 99.0263 99.8334 98.8226 97.1857C98.619 94.538 102.285 92.7049 102.285 92.7049L104.322 91.4829L104.729 92.9086Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.72 97.7186L134.572 99.2491C134.572 99.2491 137.538 105.836 135.058 104.887C132.577 103.938 132.49 99.8403 132.49 99.8403L132.257 97.4766L133.72 97.7186Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.135 70.5795C132.56 70.5795 135.337 67.8029 135.337 64.3779C135.337 60.9528 132.56 58.1763 129.135 58.1763C125.71 58.1763 122.934 60.9528 122.934 64.3779C122.934 67.8029 125.71 70.5795 129.135 70.5795Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.558 115.312L129.372 120.607V122.237H134.057V120.2C134.057 120.2 134.26 116.534 133.446 115.516C132.631 114.497 128.558 115.312 128.558 115.312Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.207 115.312L121.022 120.607V122.237H125.706V120.2C125.706 120.2 125.91 116.534 125.095 115.516C124.28 114.497 120.207 115.312 120.207 115.312Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.36 72.7764C123.36 72.7764 121.558 73.726 122.788 75.8862C124.019 78.0463 131.239 100.394 131.239 100.394L135.405 99.212L131.731 85.0784L129.628 76.1952L123.36 72.7764Z",
    fill: "#4D5AF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.456 70.8102C131.043 70.8102 133.14 68.7129 133.14 66.1258C133.14 63.5387 131.043 61.4414 128.456 61.4414C125.869 61.4414 123.771 63.5387 123.771 66.1258C123.771 68.7129 125.869 70.8102 128.456 70.8102Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.595 66.8389L129.984 76.4113L125.707 73.3563C125.707 73.3563 127.133 67.6535 126.725 67.2462L130.595 66.8389Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.595 75.5966L125.987 72.1846C125.987 72.1846 123.874 71.3195 123.263 72.3379C122.651 73.3562 119.596 88.4277 121.226 91.2791C121.226 91.2791 129.984 93.1121 131.817 92.0938L132.631 86.7984C132.631 86.7984 133.65 83.5397 132.02 81.503L130.595 75.5966Z",
    fill: "#4D5AF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.484 72.5413C124.484 72.5413 122.855 71.3193 121.429 73.356C120.004 75.3927 102.896 91.4825 102.896 91.4825L105.747 94.7412L116.949 85.3725L124.077 79.6697L124.484 72.5413Z",
    fill: "#4D5AF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.918 91.9917C131.918 91.9917 121.837 90.0569 120.818 91.4826L120.615 93.7229C120.615 93.7229 118.374 98 119.596 104.925C120.818 111.849 120.004 116.127 120.004 116.127C120.004 116.127 125.503 115.516 129.576 116.127C133.649 116.738 134.26 116.127 134.26 116.127L131.918 91.9917Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.464 121.422L128.558 121.626L130.594 136.901C130.594 136.901 128.965 143.418 130.798 143.825C132.072 144.083 133.368 144.219 134.668 144.233C134.668 144.233 136.501 146.066 138.537 145.862C139.89 145.689 141.201 145.276 142.407 144.64C142.407 144.64 142.814 143.418 141.389 143.011C139.963 142.603 136.093 141.381 135.279 137.104L134.464 121.422Z",
    fill: "#EF8459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.113 121.422L120.207 121.626L122.244 136.901C122.244 136.901 120.614 143.418 122.447 143.825C123.722 144.083 125.017 144.219 126.317 144.233C126.317 144.233 128.15 146.066 130.187 145.862C131.539 145.689 132.85 145.276 134.057 144.64C134.057 144.64 134.464 143.418 133.038 143.011C131.612 142.603 127.743 141.381 126.928 137.104L126.113 121.422Z",
    fill: "#EF8459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.304 60.417C132.722 60.417 133.871 59.2681 133.871 57.8509C133.871 56.4336 132.722 55.2847 131.304 55.2847C129.887 55.2847 128.738 56.4336 128.738 57.8509C128.738 59.2681 129.887 60.417 131.304 60.417Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.726 56.4607C134.726 55.8264 134.491 55.2146 134.066 54.7433C133.642 54.272 133.058 53.9745 132.427 53.9084C132.516 53.8992 132.605 53.8946 132.694 53.8945C133.375 53.8945 134.027 54.1649 134.509 54.6461C134.99 55.1274 135.26 55.7801 135.26 56.4607C135.26 57.1413 134.99 57.794 134.509 58.2753C134.027 58.7565 133.375 59.0269 132.694 59.0269C132.605 59.0269 132.516 59.0222 132.427 59.013C133.058 58.9469 133.642 58.6495 134.066 58.1782C134.491 57.7069 134.726 57.095 134.726 56.4607Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.414 65.629C130.776 65.629 132.691 64.48 132.691 63.0628C132.691 61.6455 130.776 60.4966 128.414 60.4966C126.052 60.4966 124.137 61.6455 124.137 63.0628C124.137 64.48 126.052 65.629 128.414 65.629Z",
    fill: "#2F2E41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1322_109733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 144.911,
    fill: "white",
    transform: "translate(0.888672 0.544434)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGs9);
export default __webpack_public_path__ + "static/media/GS9.e776f03ef0b864ebd3bb3e60e6e18c02.svg";
export { ForwardRef as ReactComponent };